import _asyncToGenerator from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import tree from '@/mixins/component-tree';
import fieldChange from '@/mixins/el-field-change';
export default {
  name: 'd2-tree-popover',
  mixins: [tree, fieldChange],
  props: {
    // 传递给 tree 组件的设置项
    tree: {
      type: Object,
      default: function _default() {
        return {};
      },
      required: false
    },
    // 总是在打开时重新计算 source
    refreshOnOpen: {
      type: Boolean,
      default: true,
      required: false
    }
  },
  data: function data() {
    return {
      active: false,
      currentValue: 0,
      currentSource: [],
      status: {
        isLoadingSource: false
      },
      boxSetting: {
        placement: 'top-start',
        title: '请选择',
        width: '230',
        trigger: 'click'
      }
    };
  },
  computed: {
    box: function box() {
      return _objectSpread(_objectSpread({}, this.boxSetting), this.$attrs);
    },
    title: function title() {
      if (this.multiple) {
        return "\u5DF2\u9009\u62E9 ".concat(this.valueLabels.length, " \u9879");
      } else {
        return this.valueLabel || '未选择或未匹配';
      }
    },
    isTreeLoading: function isTreeLoading() {
      return this.status.isLoadingSource;
    }
  },
  created: function created() {
    this.getTreeData();
  },
  watch: {
    value: {
      handler: function handler(value) {
        this.currentValue = this.tryParseMultipleString(this.value);
        this.getLabel(this.value);
      },
      immediate: true
    },
    source: 'getTreeData',
    multiple: 'getTreeData'
  },
  methods: {
    /**
     * @description 初始化
     * @description 根据 source 的数据类型设置数据
     * @description 并且计算扁平化数据优化后续计算速度
     * @description 计算一次初始的 valueLabel
     * @description 计算一次初始的 valueLabels
     */
    getTreeData: function getTreeData() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.status.isLoadingSource = true;
                _context.next = 3;
                return _this.getDataFromSource(_this.source);

              case 3:
                _this.currentSource = _context.sent;

                _this.refreshFlattenedArray(_this.currentSource);

                _this.refreshFlattenedObject(_this.currentSource);

                _this.getLabel(_this.value);

                _this.status.isLoadingSource = false;

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },

    /**
     * @description 面板打开时候触发
     */
    onBoxShow: function onBoxShow() {
      if (!this.refreshOnOpen) return;
      this.getTreeData();
    },

    /**
     * @description 面板关闭动画结束后触发
     */
    onBoxAfterLeave: function onBoxAfterLeave() {
      if (!this.refreshOnOpen) return;
      this.currentSource = [];
    },

    /**
     * @description 取消
     */
    cancle: function cancle() {
      this.currentValue = this.tryParseMultipleString(this.value);
      this.active = false;
    },

    /**
     * @description 确认
     */
    submit: function submit() {
      this.$emit('input', this.currentValue);
      this.fieldChange();
      this.active = false;
    }
  }
};